import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardService } from '../../../dashboard.service';
import { helper } from 'src/environments/helper';
import { FormControl, FormGroup } from '@angular/forms';
import {
    Observable,
    Subject,
    catchError,
    debounceTime,
    distinctUntilChanged,
    finalize,
    map,
    of,
    switchMap,
    takeUntil,
    tap,
} from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { DestinatieTableDataRow, DocumentData } from '../../../document.interface';
import { Generic, GenericCompartimentSearch } from 'src/app/interfaces/generic.interface';
import { UserOrganigramaSearchPayload } from 'src/app/interfaces/common.interface';
import { NotificationService } from 'src/app/services/notification.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-new-destination',
    templateUrl: './new-destination.component.html',
    styleUrls: ['./new-destination.component.scss'],
})
export class NewDestinationComponent implements OnInit {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;

    isLoading = false;

    tableData: DestinatieTableDataRow[] = [];

    defaultParameter: { name: string; id: number } = {
        name: '--Alegeți--',
        id: -1,
    };

    formDestinatie: FormGroup = new FormGroup({
        // id: new FormControl('', []), // Added in submitForm!
        directie_id: new FormControl(null, []),
        directie_name: new FormControl('', []),
        compartiment_id: new FormControl(null, []),
        compartiment_name: new FormControl('', []),
        user_id: new FormControl(-1, []),
        user_name: new FormControl('', []),
        // dosar_original: new FormControl('', []) // Added in addDestinatieToTableData!
    });

    private destroy$ = new Subject<void>();

    directiiDestinatie: Generic[] = [];
    filteredDirectiiDestinatie: Generic[] = [];
    directiiDestinatieControl = new FormControl();

    compartimenteDestinatie: GenericCompartimentSearch[] = [];
    compartimenteDestinatieControl = new FormControl();
    isCompartimenteDestinatieLoading = false;
    showCompartimenteDestinatieMessage = true;
    compartimenteDestinatieLoadComplete = false;

    operatoriDestinatie: Generic[] = [];
    filteredOperatoriDestinatie: Generic[] = [];
    operatoriDestinatieControl = new FormControl();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DocumentData,
        private dialogRef: MatDialogRef<NewDestinationComponent>,
        private dashboardService: DashboardService,
        private commonService: CommonService,
        private notificationService: NotificationService,
    ) { }

    ngOnInit() {
        this.loadDirectiiActiveDestinatie(0);

        this.compartimenteDestinatieControl.valueChanges.pipe(
            debounceTime(600)
        ).subscribe(compartiment => {
            if (typeof compartiment === 'string') {
                this.fetchCompartimenteDestinatie(compartiment, 0);
                this.showCompartimenteDestinatieMessage = true;
                this.compartimenteDestinatieLoadComplete = false;
            }
        });

        this.renderFieldsSearch();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    renderFieldsSearch() {
        this.directiiDestinatieControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.directiiDestinatie);
                }
                if (inputValue.length < 1) {
                    this.filteredDirectiiDestinatie = this.directiiDestinatie;
                    return of(this.directiiDestinatie);
                }
                return this.filterDirectiiDestinatie(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredDirectiiDestinatie = data;
            }),
            catchError(() => of([]))
        ).subscribe();

        this.operatoriDestinatieControl.valueChanges.pipe(
            takeUntil(this.destroy$),
            distinctUntilChanged(),
            debounceTime(150),
            switchMap((inputValue) => {
                if (typeof inputValue !== 'string') {
                    return of(this.operatoriDestinatie);
                }
                if (inputValue.length < 1) {
                    this.filteredOperatoriDestinatie = this.operatoriDestinatie;
                    return of(this.operatoriDestinatie);
                }
                return this.filterOperatoriDestinatie(inputValue);
            }),
            tap((data: any[]) => {
                this.filteredOperatoriDestinatie = data;
            }),
            catchError(() => of([]))
        ).subscribe();
    }

    loadDirectiiActiveDestinatie(blocked: number) {
        this.isLoading = true;
        this.commonService
            .getDirectiiActive(blocked)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => this.isLoading = false)
            )
            .subscribe({
                next: (results) => {
                    this.directiiDestinatie = results;

                    this.filteredDirectiiDestinatie = [...this.directiiDestinatie];
                },
                error: (error) => {
                    console.error('Error loading directii', error);
                    this.filteredDirectiiDestinatie = [];
                },
            });
    }

    onDirectiiDestinatieChange(selectedCompartiment: Generic): void {
        this.formDestinatie.controls['directie_id'].patchValue(selectedCompartiment.id);
        this.formDestinatie.controls['directie_name'].patchValue(selectedCompartiment.name);

        this.compartimenteDestinatieControl.patchValue('');
        this.formDestinatie.controls['compartiment_id'].patchValue('');
        this.formDestinatie.controls['compartiment_name'].patchValue('');

        this.operatoriDestinatie = [];
        this.filteredOperatoriDestinatie = [];
        this.operatoriDestinatieControl.patchValue('');
        this.formDestinatie.controls['user_id'].patchValue(-1);
        this.formDestinatie.controls['user_name'].patchValue('');
    }

    displayDirectiiDestinatie(selectedDirectie: Generic): string {
        return selectedDirectie && selectedDirectie.name ? selectedDirectie.name : '';
    }

    onDirectiiDestinatieBlur() {
        const currentValue = this.directiiDestinatieControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.directiiDestinatieControl.patchValue('');
            this.formDestinatie.controls['directie_id'].patchValue('');
            this.formDestinatie.controls['directie_name'].patchValue('');

            this.compartimenteDestinatieControl.patchValue('');
            this.formDestinatie.controls['compartiment_id'].patchValue('');
            this.formDestinatie.controls['compartiment_name'].patchValue('');

            this.operatoriDestinatie = [];
            this.filteredOperatoriDestinatie = [];
            this.operatoriDestinatieControl.patchValue('');
            this.formDestinatie.controls['user_id'].patchValue(-1);
            this.formDestinatie.controls['user_name'].patchValue('');
        }
    }

    fetchCompartimenteDestinatie(compartiment: string, blocked: number) {
        // const directieDestinatieValue = this.formDestinatie.get('directie_id')?.value;
        // const directie = directieDestinatieValue && directieDestinatieValue !== -1 ? directieDestinatieValue : undefined;
        if (compartiment.length >= 2) {
            this.isCompartimenteDestinatieLoading = true;
            this.commonService.searchCompartimenteActive(undefined, compartiment, blocked).subscribe({
                next: (response: any) => {
                    this.compartimenteDestinatie = response;
                    this.isCompartimenteDestinatieLoading = false;
                    this.compartimenteDestinatieLoadComplete = true;
                    this.showCompartimenteDestinatieMessage = this.compartimenteDestinatie.length === 0;
                },
                error: (err: any) => {
                    this.isCompartimenteDestinatieLoading = false;
                    this.showCompartimenteDestinatieMessage = true;
                    this.compartimenteDestinatieLoadComplete = true;
                    console.log(err);
                }
            });
        } else {
            this.compartimenteDestinatie = [];
            this.showCompartimenteDestinatieMessage = true;
            this.compartimenteDestinatieLoadComplete = false;
        }
    }

    onCompartimenteDestinatieSelected(selectedCompartiment: GenericCompartimentSearch): void {
        this.formDestinatie.controls['compartiment_id'].patchValue(selectedCompartiment.id);
        this.formDestinatie.controls['compartiment_name'].patchValue(selectedCompartiment.name);

        this.directiiDestinatieControl.setValue({
            id: selectedCompartiment.directie_id,
            name: selectedCompartiment.directie_name,
        });
        this.formDestinatie.controls['directie_id'].patchValue(selectedCompartiment.directie_id);
        this.formDestinatie.controls['directie_name'].patchValue(selectedCompartiment.directie_name);

        this.loadOperatoriDestinatie();
        this.operatoriDestinatieControl.patchValue('');
        this.formDestinatie.controls['user_id'].patchValue(-1);
        this.formDestinatie.controls['user_name'].patchValue('');
    }

    displayCompartimenteDestinatie(selectedCompartiment: GenericCompartimentSearch): string {
        return selectedCompartiment && selectedCompartiment.name ? selectedCompartiment.name : '';
    }

    onCompartimenteDestinatieBlur() {
        const currentValue = this.compartimenteDestinatieControl.value;

        // If the value is a string (not an object), it means user didn't select from list
        if (typeof currentValue === 'string') {
            this.compartimenteDestinatieControl.patchValue('');
            this.formDestinatie.controls['compartiment_id'].patchValue('');
            this.formDestinatie.controls['compartiment_name'].patchValue('');

            this.operatoriDestinatie = [];
            this.filteredOperatoriDestinatie = [];
            this.operatoriDestinatieControl.patchValue('');
            this.formDestinatie.controls['user_id'].patchValue(-1);
            this.formDestinatie.controls['user_name'].patchValue('');
        }
    }

    loadOperatoriDestinatie() {
        this.isLoading = true;
        const payload: UserOrganigramaSearchPayload = {
            directie_id: this.formDestinatie.controls['directie_id'].value,
            compartiment_id: this.formDestinatie.controls['compartiment_id'].value,
            id_document: this.data?.id_document
        }
        this.commonService
            .getUsersByOrganigrama(payload)
            .pipe(
                map((results: any) => [...results]),
                finalize(() => { this.isLoading = false })
            ).subscribe({
                next: (data) => {
                    this.operatoriDestinatie = [...data];
                    this.filteredOperatoriDestinatie = [...this.operatoriDestinatie];
                },
                error: (error) => {
                    console.error(error);
                    this.filteredOperatoriDestinatie = [];
                },
            });
    }

    onOperatoriDestinatieChange(operatorId: number): void {
        const selectedOperator = this.operatoriDestinatie.find(operator => operator.id === operatorId);

        if (selectedOperator) {
            // this.formDestinatie.controls['user_id'].patchValue(selectedOperator.id);
            this.formDestinatie.controls['user_name'].patchValue(selectedOperator.name);
        }
    }

    // displayOperatoriDestinatie(selectedOperator: Generic): string {
    //     return selectedOperator && selectedOperator.name ? selectedOperator.name : '';
    // }

    // onOperatoriDestinatieBlur() {
    //     const currentValue = this.operatoriDestinatieControl.value;

    //     // If the value is a string (not an object), it means user didn't select from list
    //     if (typeof currentValue === 'string') {
    //         this.operatoriDestinatieControl.patchValue('');
    //         this.formDestinatie.controls['user_id'].patchValue('');
    //         this.formDestinatie.controls['user_name'].patchValue('');
    //     }
    // }

    normalizeString(value: string): string {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    }

    filterDirectiiDestinatie(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.directiiDestinatie.filter(directie =>
            this.normalizeString(directie.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    filterOperatoriDestinatie(searchTerm: string): Observable<any[]> {
        const normalizedSearchTerm = this.normalizeString(searchTerm);

        const filtered = this.operatoriDestinatie.filter(compartiment =>
            this.normalizeString(compartiment.name).includes(normalizedSearchTerm)
        );

        return of(filtered);
    }

    getIdentifier(directie_id: number, compartiment_id: number, user_id: number): string {
        const directieIdS = directie_id ? directie_id.toString() : '0';
        const compartimentIdS = compartiment_id ? compartiment_id.toString() : '0';
        const userIdS = user_id ? user_id.toString() : '0';
        const identifier = directieIdS + compartimentIdS + userIdS;
        return identifier;
    }

    addDestinatieToTableData() {
        const { directie_id, directie_name, compartiment_id, compartiment_name, user_id, user_name } = this.formDestinatie.value;
        if (!directie_id) { return };

        const newRowIndentifier = this.getIdentifier(directie_id, compartiment_id, user_id);
        const isRowAdded = this.tableData.some(row => this.getIdentifier(row.directie_id, row.compartiment_id, row.user_id) === newRowIndentifier);
        if (isRowAdded) { return };

        const newRow: DestinatieTableDataRow = {
            id: null,
            directie_id,
            directie_name,
            compartiment_id,
            compartiment_name,
            user_id,
            user_name,
            dosar_original: true,
        }

        this.tableData.push(newRow);
        this.formDestinatie.patchValue({
            directie_id: null,
            directie_name: '',
            compartiment_id: null,
            compartiment_name: '',
            user_id: -1,
            user_name: '',
        });
        this.resetFormDestinatieFields();
    }
    resetFormDestinatieFields() {
        this.filteredDirectiiDestinatie = this.directiiDestinatie;
        this.directiiDestinatieControl.setValue('');

        this.compartimenteDestinatie = [];
        this.compartimenteDestinatieControl.setValue('');

        this.operatoriDestinatie = [];
        this.filteredOperatoriDestinatie = [];
        this.operatoriDestinatieControl.setValue('');

        this.destroy$.next();
        this.destroy$.complete();
        this.renderFieldsSearch();
    }

    deleteTableDataRow(index: number) {
        this.tableData.splice(index, 1);
    }
    checkDocOriginal(index: number) {
        this.tableData[index].dosar_original = !this.tableData[index].dosar_original;
    }

    submitForm() {
        Swal.fire({
            title: helper.dialogConfig.commonTitles.areYouSure,
            text: 'Vă rugăm să confirmați acest proces!',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: helper.dialogConfig.colorButtons.standard,
            confirmButtonText: helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {
                this.submitNewDestination();
            }
        });
    }

    submitNewDestination() {
        this.isLoading = true;

        const destinatie = this.tableData.map((item, index) => {
            item.id = index + 1
            return item;
        });

        const payload = {
            destinatie: destinatie,
        }

        // console.log(destinatie);
        this.dashboardService
            .addActivityDestination(this.data?.id_document, payload)
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: (res) => {
                    Swal.fire({
                        title: helper.dialogConfig.headers.success,
                        text: 'Documentație actualizată cu succes',
                        icon: 'success',
                        confirmButtonText: helper.dialogConfig.buttonLabels.ok,
                        reverseButtons: true,
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.isConfirmed) {
                            this.dialogRef.close({ success: true });
                        }
                    });
                },
                error: (err) => {
                    let msg;
                    try {
                        // try to catch the message from server
                        msg = err.error.errors.message[0];
                    } catch (error) {
                        // controll output message
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        this.errorTitle,
                        msg,
                        this.errorIcon
                    );
                }
            });
    }
}
